import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { ModalProps } from '../../../holidays/components/types'
import { programSchema } from '../../schema'
import { createProgram } from '../../api'
import { useAppDispatch } from '../../../../redux/hook'
import { addprogram } from '../../slice/trainingslice'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'

interface LocFormValues {
    title: string
    description: string
}
const CreateFolder = ({ show, onClose }: ModalProps) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Create Training Program"
            body={
                <Formik
                    initialValues={{
                        title: '',
                        description: '',
                    }}
                    validationSchema={programSchema}
                    onSubmit={async (
                        values,
                        actions: FormikHelpers<LocFormValues>
                    ) => {
                        const payload = {
                            title: values.title,
                            description: values.title,
                        }
                        try {
                            const response = await createProgram(payload)
                            dispatch(
                                addprogram({
                                    id: response.data,
                                    payload,
                                })
                            )
                            dispatch(
                                SHOW_NOTIFICATION({
                                    type: 'success',
                                    message: 'Program created successfully',
                                })
                            )
                        } catch (err) {
                            // Handle any errors here
                            console.error('Error fetching:', err)
                        }
                        actions.setSubmitting(false)
                        onClose(false)
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <div className="link-form">
                            <form onSubmit={handleSubmit}>
                                <InputField
                                    type="text"
                                    name="title"
                                    lable="Training Program"
                                    value={values.title}
                                    placeholder=""
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.title}
                                    touched={touched.title}
                                />
                                <div className="footer-block">
                                    <Button
                                        disabled={isSubmitting}
                                        type="submit"
                                    >
                                        SAVE
                                    </Button>
                                    <Button
                                        disabled={isSubmitting}
                                        type="submit"
                                        variant="outline-success"
                                        onClick={() => onClose(false)}
                                    >
                                        CANCEL
                                    </Button>
                                </div>
                            </form>
                        </div>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default CreateFolder
